module.exports = __webpack_public_path__ + "static/media/money.79581676.png";